import React from 'react'
import { ArrowRight, Button } from '@astrid/components'
import ScoreIndicator from 'components/ScoreIndicator/ScoreIndicator'
import type { CEFRLevels, GESELevels } from 'store/services/Book'

import styles from './WordsPracticeSummary.module.scss'

type WordsPractiseSummaryProps = {
  bookData?: {
    title: string
    cefrLevel: CEFRLevels
    geseLevel: GESELevels
    points: number
  }
  scoresComparison: Array<{
    word: string
    was: number
    is: number
  }>
  onFinish: () => void
}

const WordsPracticeSummary: React.FC<WordsPractiseSummaryProps> = ({ bookData, onFinish, scoresComparison }) => {
  // const isPerfectScore = scoresComparison.every(({ is }) => is === 100)

  // useEffect(() => {
  //   if (isPerfectScore) {
  //     api.post('/book-progress/achievement')
  //   }
  // }, [isPerfectScore])

  return (
    <div className={styles.wrapper}>
      <div className={styles.scroll}>
        <div className={styles.outerContainer}>
          {/* [feature/pronunciation-pro] */}
          {/* <div className={styles.container} data-perfect={isPerfectScore}> */}
          <div className={styles.container}>
            <div className={styles.innerContainer}>
              <div className={`${styles.headingContainer} ${!bookData ? styles.withMargin : ''}`}>
                <h1 className={styles.heading}>
                  {/* [feature/pronunciation-pro] */}
                  {/* {bookData
                    ? isPerfectScore
                      ? 'Check out the improvement!'
                      : 'You are really improving!'
                    : 'Well done!'} */}
                  Well done!
                </h1>
              </div>
              {/* [feature/pronunciation-pro] */}
              {/* {bookData && (
                <div className={styles.levelSummary}>
                  <div className={styles.row}>
                    <span className={styles.text}>Difficulty:</span>
                  </div>
                  <div className={styles.row}>
                    <span className={styles.text}>Stars:</span>
                    <div className={styles.starCircle}>⭐</div>
                    <span className={styles.text}>{bookData.points}</span>
                  </div>
                </div>
              )} */}
              <div className={styles.box}>
                <div className={styles.header}>
                  <span className={styles.text}>Previously</span>
                  <span className={styles.text}>Now</span>
                </div>
                <div className={styles.column}>
                  {scoresComparison.map(({ was, is, word }) => (
                    <div key={word + is} className={styles.comparisonRow}>
                      <div className={styles.left}>
                        <ScoreIndicator
                          value={was}
                          sizeInPx={50}
                          fontSize={was === 100 ? '13px' : '16px'}
                          strokeWidthInPx={9}
                          colorsThresholds={{
                            LOW: 50,
                            HIGH: 80
                          }}
                        />
                      </div>
                      <div className={styles.filler} />
                      <div className={`${styles.word} ${word.length > 12 ? styles.long : ''}`}>{word}</div>
                      <div className={styles.right}>
                        <ScoreIndicator
                          value={is}
                          sizeInPx={50}
                          fontSize={is === 100 ? '13px' : '16px'}
                          strokeWidthInPx={9}
                          colorsThresholds={{
                            LOW: 50,
                            HIGH: 80
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <Button color="light-blue" className={styles.finishButton} onClick={onFinish} aria-label={'Finish practice'}>
            <ArrowRight />
          </Button>
          {/* <div className={styles.shadow} /> */}
          {/* {isPerfectScore && <div className={styles.shadow} />} */}
        </div>
      </div>
    </div>
  )
}

export default WordsPracticeSummary
